/* Collection */
class OrderCollection extends App.Collections.BaseCollection {
    url = 'Order';
    model = App.Models.Order;

    searchWithCriteria = (obj) => {
        return Monet.Model.searchWithCriteria({
            options: obj,
            model: new this.model
        });
    }

    getIds = () => {
        const arrayIds = [];
        this.models.forEach(model => arrayIds.push(model.get('id')));

        return arrayIds;
    }
}

App.Collections.Orders = OrderCollection;